/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem5ExemptEditor extends Serenity.Extensions.GridEditorBase<PsAdvPromoItem5ExemptRow> {
        protected getColumnsKey() { return "AdvPromo.PsAdvPromoItem5Exempt"; }
        protected getDialogType() { return PsAdvPromoItem5ExemptDialog; }
        protected getLocalTextPrefix() { return PsAdvPromoItem5ExemptRow.localTextPrefix; }

        public qnNo: number;

        public myPassValue1: string;        
        

        constructor(container: JQuery) {
            super(container);
        
        }      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            //let self = this;
            //self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text("Add รายการยกเว้น"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-add',
                    onClick: () => {
                        this.createEntityDialog(this.getItemType(), dlg => {

                            var diag = PsAdvPromoItem5Dialog
                            var dialog = dlg as PsAdvPromoItem5ExemptDialog;
                            dialog.onSave = (opt, callback) => this.save(opt, callback);
                            var entity = this.getNewEntity() as PsAdvPromoItem5ExemptRow;

                            entity.PmGroupId = this.myPassValue1;
                            
                            



                            dialog.loadEntityAndOpenDialog(entity, false);
                           
                        });
                    },
                }
            );
            
                
            return buttons;
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

    }
}

